var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "uil-default",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .spinner0{animation: one 1s infinite}\n    .spinner1{animation: one 1s .083s infinite}\n    .spinner2{animation: one 1s .166s infinite}\n    .spinner3{animation: one 1s .25s infinite}\n    .spinner4{animation: one 1s .33s infinite}\n    .spinner5{animation: one 1s .417s infinite}\n    .spinner6{animation: one 1s .5s infinite}\n    .spinner7{animation: one 1s .583s infinite}\n    .spinner8{animation: one 1s .667s infinite}\n    .spinner9{animation: one 1s .75s infinite}\n    .spinner10{animation: one 1s .833s infinite}\n    .spinner11{animation: one 1s .917s infinite}\n    @keyframes one {\n      0% {\n        opacity: 1;\n      }\n      100% {\n        opacity: 0;\n      }\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "none",
    className: "bk"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner0",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(0 50 50) translate(0 -30)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner1",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(30 50 50) translate(0 -30)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner2",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(60 50 50) translate(0 -30)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner3",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(90 50 50) translate(0 -30)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner4",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(120 50 50) translate(0 -30)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner5",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(150 50 50) translate(0 -30)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner6",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(180 50 50) translate(0 -30)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner7",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(210 50 50) translate(0 -30)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner8",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(240 50 50) translate(0 -30)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner9",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(270 50 50) translate(0 -30)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner10",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(300 50 50) translate(0 -30)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner11",
    x: 46.5,
    y: 40,
    width: 7,
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(330 50 50) translate(0 -30)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.706ca9f0.svg";
export { ForwardRef as ReactComponent };